import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// eslint-disable-next-line @angular-eslint/use-component-selector
@Component({
  template: '',
})
export abstract class DestroyableComponent implements OnDestroy {
  protected _destroyed$: Subject<void> = new Subject<void>();

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
